import Button from 'components/button';
import styles from './styles.module.scss';

interface IFormConfirm {
  onDismiss: () => void;
  onAgree: () => void;
  title: string;
  isLoading: boolean;
  nameAction?: string;
  text?: string;
  withoutCancel?: boolean;
  isSwitchActions?: boolean;
}

const BASE_NAME_ACTION = 'удалить';

const FormConfirm = ({
  title,
  withoutCancel,
  isLoading,
  text,
  nameAction,
  onAgree,
  onDismiss,
  isSwitchActions,
}: IFormConfirm) => {
  const getActions = () => {
    if (isSwitchActions) {
      return (
        <div className={styles.btnFlex}>
          <Button
            label={nameAction ? nameAction : BASE_NAME_ACTION}
            loading={isLoading}
            onClick={onAgree}
            variant='gray'
          />
          {!withoutCancel && <Button label='отмена' onClick={onDismiss} />}
        </div>
      );
    }
    return (
      <div className={styles.btnFlex}>
        {!withoutCancel && <Button variant='gray' label='отмена' onClick={onDismiss} />}
        <Button
          label={nameAction ? nameAction : BASE_NAME_ACTION}
          loading={isLoading}
          onClick={onAgree}
        />
      </div>
    );
  };

  return (
    <div className={styles.container}>
      <p className={styles.title}>{title}</p>
      {text && <div className={styles.text}>{text}</div>}
      {getActions()}
    </div>
  );
};

export default FormConfirm;
